import React from "react";
import { Input } from "semantic-ui-react";

interface Props {
  value: string
  onChange: (v: string) => void
}

const PostalCode = (props: Props) => {
  return <Input
    icon={"search"}
    fluid
    placeholder={RESX.Address.PostalCode}
    value={props.value}
    onChange={e => { props.onChange(e.currentTarget.value); }}
  />;
};

export default PostalCode;